/* ============================================
   EVICTION NOTICE — Custom JavaScript
   Scroll reveal, sticky cart, offer card selection
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* --- Scroll Reveal --- */
  const revealElements = document.querySelectorAll('.en-reveal');
  if (revealElements.length > 0) {
    const revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('en-reveal--visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach(function(el) {
      revealObserver.observe(el);
    });
  }

  /* --- Sticky Cart (Mobile) --- */
  const stickyCart = document.querySelector('.en-sticky-cart');
  const heroSection = document.querySelector('[data-en-hero]');
  if (stickyCart && heroSection) {
    const stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyCart.classList.remove('en-sticky-cart--visible');
        } else {
          stickyCart.classList.add('en-sticky-cart--visible');
        }
      });
    }, { threshold: 0 });

    stickyObserver.observe(heroSection);
  }

  /* --- Offer Card Selection --- */
  const offerCards = document.querySelectorAll('.en-offer-card[data-variant-id]');
  offerCards.forEach(function(card) {
    card.addEventListener('click', function() {
      offerCards.forEach(function(c) { c.classList.remove('en-offer-card--active'); });
      card.classList.add('en-offer-card--active');

      // Update hidden variant input if present
      var variantId = card.getAttribute('data-variant-id');
      var variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }

      // Update displayed price
      var price = card.getAttribute('data-price');
      var priceDisplay = document.querySelector('[data-en-price-display]');
      if (priceDisplay && price) {
        priceDisplay.textContent = price;
      }
    });
  });

  /* --- FAQ Accordion Arrow Rotation --- */
  const faqDetails = document.querySelectorAll('.en-faq details');
  faqDetails.forEach(function(detail) {
    detail.addEventListener('toggle', function() {
      var arrow = detail.querySelector('.en-faq__arrow');
      if (arrow) {
        arrow.style.transform = detail.open ? 'rotate(180deg)' : 'rotate(0deg)';
      }
    });
  });

  /* --- Tab Switching (Solution Section) --- */
  const tabButtons = document.querySelectorAll('[data-en-tab-btn]');
  tabButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tabGroup = btn.closest('[data-en-tabs]');
      if (!tabGroup) return;

      var targetId = btn.getAttribute('data-en-tab-btn');

      // Deactivate all buttons and panels in this group
      tabGroup.querySelectorAll('[data-en-tab-btn]').forEach(function(b) {
        b.classList.remove('en-tab--active');
        b.setAttribute('aria-selected', 'false');
      });
      tabGroup.querySelectorAll('[data-en-tab-panel]').forEach(function(p) {
        p.hidden = true;
      });

      // Activate clicked button and target panel
      btn.classList.add('en-tab--active');
      btn.setAttribute('aria-selected', 'true');
      var targetPanel = tabGroup.querySelector('[data-en-tab-panel="' + targetId + '"]');
      if (targetPanel) {
        targetPanel.hidden = false;
      }
    });
  });

});
